import React from 'react'

import Layout from '../App/layout'
import ContentLayout from '../../components/utility/layoutContent'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'
import SupplierOrderReviewIndexContainer from './SupplierOrderReviewIndexContainer'

class SupplierOrderReviewIndexPage extends React.Component {
    componentDidMount() {
        document.title = 'Supplier Order Reviews | OSH CRM'
    }

    render () {
        return (
            <Layout>
                <LayoutContentWrapper breadcrumbs={[
                        { path: '/supplier_order_reviews', name: 'Supplier Order Reviews' }
                    ]}>
                    <ContentLayout>
                      <SupplierOrderReviewIndexContainer />
                    </ContentLayout>
                </LayoutContentWrapper>
            </Layout>
        )
    }
}

export default SupplierOrderReviewIndexPage
